import { SerializationService as SerSvc } from 'aautil';
import { Serialize } from 'aautil';

export class SendMailFormData {
  @Serialize()
  text: string;

  @Serialize()
  id: number;

  @Serialize()
  useMail: boolean;

  @Serialize()
  useTel: boolean;

  @Serialize()
  mail: string;

  @Serialize()
  tel: string;

  constructor(text?: string, id?: number, useMail?: boolean, useTel?: boolean, mail?: string, tel?: string) {
    if (text) this.text = text;
    if (id) this.id = id;
    if (useMail) this.useMail = useMail;
    if (useTel) this.useTel = useTel;
    if (mail) this.mail = mail;
    if (tel) this.tel = tel;
  }
}
